var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-head f-b-c"},[_c('h3',{staticClass:"block-head-title",class:_vm.icon},[_vm._v(_vm._s(_vm.title)+" "),_c('span',[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }